/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export class LatLng {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(lat:number, lng:number) {
			this.lat = lat;
			this.lng = lng;

			this.zoomLevel = -1;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public calcPixelCoord(zoomLevel:number):LatLng {
			this.zoomLevel = zoomLevel;

			if (this.pixel == null) {
				this.pixel = new THREE.Vector2();
				this.tile = new THREE.Vector2();
				this.tilePixel = new THREE.Vector2();
			}

			// lat/lng to pixel
			this.pixel.x = Math.pow(2, this.zoomLevel + 7) * (this.lng / 180 + 1);
			this.pixel.y = (Math.pow(2, this.zoomLevel + 7) / Math.PI) * (-Math.atanh(Math.sin(((Math.PI / 180) * this.lat))) + Math.atanh(Math.sin((Math.PI / 180) * 85.05112878)));

			// pixel to tile
			this.tile.x = Math.floor(this.pixel.x / 256);
			this.tile.y = Math.floor(this.pixel.y / 256);

			// pixel position in tile
			this.tilePixel.x = this.pixel.x % 256;
			this.tilePixel.y = this.pixel.y % 256;

			return this;
		}

		public getLat():number {
			return this.lat;
		}

		public getLng():number {
			return this.lng;
		}

		public getPixel():THREE.Vector2 {
			return this.pixel;
		}

		public getTile():THREE.Vector2 {
			return this.tile;
		}

		public getTilePixel():THREE.Vector2 {
			return this.tilePixel;
		}

		public getZoomLevel():number {
			return this.zoomLevel;
		}

		public getTileTopLeft(calcPixelCoord:boolean = false):LatLng {
			const p:LatLng = Unit.tileToLatLng(this.tile.x, this.tile.y, this.zoomLevel);
			if (calcPixelCoord) p.calcPixelCoord(this.zoomLevel);
			return p;
		}

		public getTileTopRight(calcPixelCoord:boolean = false):LatLng {
			const p:LatLng = Unit.tileToLatLng(this.tile.x + 1, this.tile.y, this.zoomLevel);
			if (calcPixelCoord) p.calcPixelCoord(this.zoomLevel);
			return p;
		}

		public getTileBottomLeft(calcPixelCoord:boolean = false):LatLng {
			const p:LatLng = Unit.tileToLatLng(this.tile.x, this.tile.y + 1, this.zoomLevel);
			if (calcPixelCoord) p.calcPixelCoord(this.zoomLevel);
			return p;
		}

		public getTileBottomRight(calcPixelCoord:boolean = false):LatLng {
			const p:LatLng = Unit.tileToLatLng(this.tile.x + 1, this.tile.y + 1, this.zoomLevel);
			if (calcPixelCoord) p.calcPixelCoord(this.zoomLevel);
			return p;
		}

		public getTileBounds(calcPixelCoord:boolean = false):LatLng[] {
			return [
				this.getTileTopLeft(calcPixelCoord),
				this.getTileTopRight(calcPixelCoord),
				this.getTileBottomLeft(calcPixelCoord),
				this.getTileBottomRight(calcPixelCoord)
			];
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private lat:number;
		private lng:number;

		private pixel:THREE.Vector2;

		private tile:THREE.Vector2;
		private tilePixel:THREE.Vector2;

		private zoomLevel:number;
	}
}
